import '@eventr/common-storybook/dist/index.css'
import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './data/apiClients'
import './data/interseptors'
import './feat/appState/appStateListener'
import './index.css'
import { logInterceptor } from './logInterceptor'

logInterceptor()
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <Suspense fallback="addloading">
        <App />
    </Suspense>
)
